/** Au-dessus du bandeau cookies et de la bottom nav pendant la saisie. */
export const SEARCH_SUGGESTIONS_Z_INDEX = 21000;

/** Au-dessus de la bottom nav (~9999) et du contenu général. */
export const COOKIE_BANNER_Z_INDEX = 20500;
